import { TFunction } from 'i18next';
import { SuggestedFaqStatus } from '@/models/suggestedFaq.model';

const statusLabels: Record<SuggestedFaqStatus, string> = {
  [SuggestedFaqStatus.PENDING]: 'status_pending',
  [SuggestedFaqStatus.EDITED]: 'status_edited',
  [SuggestedFaqStatus.APPROVED]: 'status_approved',
  [SuggestedFaqStatus.REJECTED]: 'status_rejected',
};

export const getSuggestedFaqStatusLabel = (status: SuggestedFaqStatus, t: TFunction): string => t(statusLabels[status]);
